import { layerStatistics } from "api/layer";

type LayerPeril =
  | "fathom"
  | "catnet"
  | "crs"
  | "event"
  | "Climate/CRS"
  | "Climate/FHR"
  | "Climate/Components";
type LayerStatus = "0" | "1";

interface LayerStatsBase {
  eventType: string;
  status: LayerStatus;
  locationAmount?: number;
  executeInterval: number;
  coordinates?: string;
  messageInfo?: string;
  traceInfo?: string;
  layers?: string[];
}

interface HazardLayerStats extends LayerStatsBase {
  layers?: string[];
}

interface PerilLayerStats extends LayerStatsBase {
  perils: LayerPeril;
  layerAmount?: number;
}

const isFathomLayer = (layerId: string) => layerId.includes("Fathom");

const joinLayers = (layers?: string[]) => layers?.filter(Boolean).join(",");

export const buildNodeCoordinates = (
  nodes?: Array<{ longitude: number | string; latitude: number | string }>
): string => {
  return (nodes || [])
    .map((item) => `${item.longitude},${item.latitude}`)
    .join(";");
};

export const buildLocationCoordinates = (
  locations?: Array<{
    coordinates: { longitude: number | string; latitude: number | string };
  }>
): string => {
  return (locations || [])
    .map((item) => `${item.coordinates.longitude},${item.coordinates.latitude}`)
    .join(";");
};

export const reportHazardLayerStatistics = ({
  layers,
  ...base
}: HazardLayerStats): void => {
  const layerList = layers || [];
  if (!layerList.length) {
    return;
  }

  const fathomCount = layerList.filter(isFathomLayer).length;
  const catnetCount = layerList.length - fathomCount;
  const fathomLayers = layerList.filter(isFathomLayer);
  const catnetLayers = layerList.filter((layerId) => !isFathomLayer(layerId));

  if (fathomCount > 0) {
    layerStatistics({
      ...base,
      perils: "fathom",
      layerAmount: fathomCount,
      layers: joinLayers(fathomLayers)
    });
  }

  if (catnetCount > 0) {
    layerStatistics({
      ...base,
      perils: "catnet",
      layerAmount: catnetCount,
      layers: joinLayers(catnetLayers)
    });
  }
};

export const reportPerilLayerStatistics = ({
  perils,
  layerAmount,
  layers,
  ...base
}: PerilLayerStats): void => {
  if (!layerAmount) {
    return;
  }

  layerStatistics({
    ...base,
    perils,
    layerAmount,
    layers: joinLayers(layers)
  });
};
